/*
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: Smart Chow
 * @LastEditTime: 2022-04-12 16:54:09
 * @FilePath: /nqc-ui/src/apps/modules/qc-check/_store/index.js
 */

const state = {
  isRefreshTable: false
}

const mutations = {
  SET_ISREFRESH_TABLE: (state, payload) => {
    state.isRefreshTable = payload
  }
}

const actions = {}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
